// API Data
export interface ITimeOffTemplateData {
  id?: number;
  name?: string;
  timeoffs?: ITimeOffTypeData[] | null;
}

export interface ITimeOffTypeData {
  id?: number;
  name?: string;
  code?: number | null;
  policy?: ITimeOffPolicyData | null;
}

export interface ITimeOffPolicyData {
  id?: number;
  name?: string;
  effective_date?: string | Date | null;
  expiry_date?: string | Date | null;
  is_accrual_supported?: boolean;
  is_entitlement_earned?: boolean;
  is_carryover_supported?: boolean;
  is_overdraft_supported?: boolean;
  is_reminder_supported?: boolean;
  timeoff_display_option?: number;
  yearly_entitlement?: number;
  timeoff_unit?: ITimeOffUnitData | number;
  timeoff?: number | ITimeOffTypeData;
  timeoff_duration_type?: TimeOffDurationType;
  entitlement_amount_validity?: number;
}

export interface ITimeOffTemplateFieldErrorData {
  name: string[];
  timeoffs?: ITimeOffTypeFieldError;
}

export interface ITimeOffTypeFieldErrorData {
  name?: string[];
  policy?: ITimeOffPolicyFieldError;
}

export interface ITimeOffPolicyFieldErrorData {
  timeoff?: string[];
  effective_date?: string[];
  expiry_date?: string[];
  yearly_entitlement?: string[];
  is_carryover_supported?: string[];
  entitlement_amount_validity?: string[];
}

export interface ITimeOffUnitData {
  value?: TimeOffUnitEnum;
  display_unit?: string;
}
export interface ITimeOffUnit extends ITimeOffUnitData {
  validate(): boolean;
}

// Business Logic Interface
export interface ITimeOffUnit extends ITimeOffUnitData {
  validate(): boolean;
}

export interface ITimeOffTemplate extends ITimeOffTemplateData {
  timeoffs?: ITimeOffType[] | null;
  validate(): boolean;
}
export interface ITimeOffPolicy extends ITimeOffPolicyData {
  timeoff_unit?: ITimeOffUnit | number;

  validate(): boolean;
}

export interface ITimeOffType extends ITimeOffTypeData {
  /**
   * @property
   * getter for fullName
   */
  fullName?: string;

  validate(): boolean;
  toString(): string;
}

export interface ITimeOffType extends ITimeOffTypeData {
  validate(): boolean;
}

export interface ITimeOffTemplateFieldError
  extends ITimeOffTemplateFieldErrorData {
  clearErrors(): void;
}

export interface ITimeOffPolicyFieldError extends ITimeOffPolicyFieldErrorData {
  clearErrors(): void;
}

export interface ITimeOffTypeFieldError extends ITimeOffTypeFieldErrorData {
  clearErrors(): void;
}

export enum TimeOffUnitEnum {
  Days,
  Hours
}

export enum TimeOffDurationType {
  Static,
  Dynamic
}
